
import React from 'react';

const stats = [
  { value: '50+', label: 'Federal Programs' },
  { value: '5 min', label: 'Quick Assessment' },
  { value: '100%', label: 'Secure & Private' },
  { value: '24/7', label: 'Support Hub' },
];

const StatsSection: React.FC = () => {
  return (
    <section className="bg-gradient-to-r from-[#2ECC40] to-[#0074D9]">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 gap-8 text-center md:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label}>
              <p className="text-4xl lg:text-5xl font-extrabold text-white">{stat.value}</p>
              <p className="mt-1 text-base font-medium text-green-100">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
